import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { createPayment, listPayments } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { PaymentForm } from "../features/acct/PaymentForm";
import { PaymentList } from "../features/acct/PaymentList";
import { TransferPanel } from "../features/acct/TransferPanel";
import { useAcctLookups } from "../features/acct/useAcctLookups";
import { useTransfers } from "../features/acct/useTransfers";
import { useFeatures } from "../hooks/useFeatures";

export default function AcctPaymentsPage() {
  const { t } = useTranslation();
  const lookups = useAcctLookups();
  const { cash_transfers: transfersOn } = useFeatures();
  const [payments, setPayments] = useState([]);
  const [pay, setPay] = useState({ kind: "supplier_payment", party_id: "", cashbox_id: "", amount: "" });

  const load = useCallback(async () => {
    setPayments(await listPayments({}));
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const tr = useTransfers(transfersOn, lookups.reload);
  const parties = pay.kind === "supplier_payment" ? lookups.suppliers : lookups.customers;

  const submitPay = async () => {
    await createPayment({
      ...pay,
      date: new Date().toISOString().slice(0, 10),
      amount: Number(pay.amount),
      party_id: pay.party_id || parties[0]?.id,
      cashbox_id: pay.cashbox_id || lookups.boxes[0]?.id,
    });
    toast.success(t("acct.paymentSaved"));
    setPay({ ...pay, amount: "" });
    load();
    lookups.reload();
  };

  return (
    <AcctShell titleKey="payments">
      <PaymentForm pay={pay} setPay={setPay} parties={parties} boxes={lookups.boxes} onSubmit={submitPay} />
      <PaymentList payments={payments} />
      {transfersOn ? (
        <TransferPanel
          move={tr.move}
          setMove={tr.setMove}
          boxes={lookups.boxes}
          transfers={tr.transfers}
          plan={tr.plan}
          onSubmit={tr.submit}
          onApprove={tr.approve}
        />
      ) : null}
    </AcctShell>
  );
}
